// Social-preview (Open Graph) images, kept as PURE DATA for the same reason as
// favicons.ts: both the app (src/lib/seo.ts) and vite.config.ts — which rewrites
// index.html's static og:image at build time — need these paths, and
// vite.config.ts cannot import anything renderable.
//
// The files live in public/ (unhashed, stable) because a crawler fetches them
// with no page context, and because a preview URL wants to stay valid for as
// long as links to it exist.
//
// 1200x630 is the 1.91:1 ratio Facebook, X and LINE render as a large card; the
// dimensions are declared in the meta tags, so a replacement image must keep
// them or the declaration becomes a lie.
export const BRAND_OG_IMAGES: Record<string, string> = {
  smartmarket: "/brand/smartmarket/og.jpg",
  richpoll: "/brand/richpoll/og.jpg",
};

export const OG_IMAGE_WIDTH = "1200";
export const OG_IMAGE_HEIGHT = "630";

// The LEGACY default-preview path, per brand.
//
// `/og-default.png` is not ours to rename: api-gateway hardcodes it as the
// image for every crawler document it cannot fill from the catalog — a market
// with no artwork of its own, or a handle that resolves to nothing — and links
// shared before SM-334 still point straight at it. It is fetched from the
// web-client origin, so on richpoll.com it was serving the SmartMarket card:
// the brand leak this map closes.
//
// The path stays FIXED for every brand; what changes is which file the build
// puts there (see the brand plugin in vite.config.ts). Every entry must be a
// real 1200x630 PNG, because the URL's extension is the one the gateway
// declares and nginx types the response from it.
export const OG_DEFAULT_PATH = "/og-default.png";

export const BRAND_OG_DEFAULT_SOURCES: Record<string, string> = {
  // Already at the served path — the shared default was always this brand's.
  smartmarket: OG_DEFAULT_PATH,
  richpoll: "/brand/richpoll/og-default.png",
};
